import { render, staticRenderFns } from "./TabRateCodeComponent.vue?vue&type=template&id=568f7996&scoped=true"
import script from "./TabRateCodeComponent.vue?vue&type=script&lang=js"
export * from "./TabRateCodeComponent.vue?vue&type=script&lang=js"
import style0 from "./TabRateCodeComponent.vue?vue&type=style&index=0&id=568f7996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568f7996",
  null
  
)

export default component.exports